<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item" v-show="!loading">
      <transition @enter="scaleUp">
        <md-card class="card-title" v-bind:key="exam.name" v-if="exam.name">
        <md-card-header>
          <div class="md-layout md-alignment-center-space-between">
            <span class="md-display-1">{{exam.name}}</span>
            
            <md-button class="md-icon-button md-primary print-action" @click="printExam">
              <md-icon>print</md-icon>
              <md-tooltip md-direction="top">Print Exam</md-tooltip>
            </md-button>
          </div>
        </md-card-header>
          <md-divider></md-divider>
          <md-card-content>
            <div class="md-subheading text-justify">{{exam.description}}</div>
          </md-card-content>
        </md-card>
      </transition>

        <md-card class="card-question"
          :class="{'essay-question': question.questionType !== 'MultipleChoice'}"
          v-for="question in exam.questions"
          v-bind:key="question.id"
          style="max-width: 768px;">
          <md-card-header>
            <p class="md-subheading text-justify">{{question.number}}. {{question.question}}</p>
          </md-card-header>
          <md-divider></md-divider>
          <md-card-content>
            <div v-if="question.questionType == 'MultipleChoice'">
              <div
                class="choice-row-screen"
                v-for="choice in question.choices"
                v-bind:key="choice.number">
                  <label class="choice-option-screen">
                    <input
                      class="choice-input-screen"
                      type="radio"
                      :name="`question-${question.id}`"
                      :checked="question.value === choice.id"
                      @change="captureMultipleChoiceChange(question.id, choice.id)">
                    <span class="choice-fake-radio" :class="{ selected: question.value === choice.id }"></span>
                    <span class="choice-label-screen">{{formatChoiceLetter(choice)}}.</span>
                    <span class="choice-text-screen text-justify">{{formatChoiceText(choice)}}</span>
                  </label>
              </div>
              <div class="print-choice-list">
                <div
                  class="print-choice-item"
                  v-for="choice in question.choices"
                  v-bind:key="`print-${choice.number}`">
                  <span class="print-choice-box" :class="{ selected: question.value === choice.id }"></span>
                  <span class="print-choice-label">{{formatChoiceLetter(choice)}}.</span>
                  <span class="print-choice-text">{{formatChoiceText(choice)}}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <question-text
                v-model="question.value"
                :questionId="question.id"
                :studentWorkId="id"></question-text>
            </div>
          </md-card-content>
          <md-card-expand v-if="question.notice">
            <md-card-actions md-alignment="space-between">
              <div>
              </div>
              <md-card-expand-trigger>
                <md-button class="md-primary">Notice</md-button>
              </md-card-expand-trigger>
            </md-card-actions>

            <md-card-expand-content>
              <md-card-content class="md-caption">
              <p class="text-indent">{{question.notice}}</p>
              </md-card-content>
            </md-card-expand-content>
          </md-card-expand>
        </md-card>
    </div>
    <md-snackbar
      md-position="center"
      :md-active.sync="saving"
      md-persistent
    >
      <span>Saving...</span>
    </md-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import { gsap } from "gsap";
import _ from 'lodash';
import QuestionText from '@/components/QuestionText.vue';
import GroupTransition from "@/components/GroupTransition.vue";

export default {
  components: {
    QuestionText,
    GroupTransition,
  },
  name: 'FillForm',
  data: () => ({
    formMode: 'preview',
    loading: true,
    submitting: false,
    saving: false,
    id: -1,
    answers: {},
    text: {},
    wordCounts: {},
    exam: {},
    model:
    {
      name: '',
      dateDue: null,
      instructions: '',
      examId: -1,
      state: ''
    },
    originalTitle: '',
    printContext: {
      studentName: 'Unknown Student',
      cohortLabel: 'Unknown Cohort',
      enrollmentId: '---',
      assignmentName: ''
    }
  }),
  computed: {
  },
  methods: {
    printExam()
    {
      const route = this.$router.resolve({
        name: 'print-exam',
        params: { id: this.id },
        query: {
          print: '1',
          studentName: this.printContext.studentName,
          cohort: this.printContext.cohortLabel,
          enrollmentId: this.printContext.enrollmentId,
          assignmentName: this.printContext.assignmentName
        }
      });

      window.open(route.href, '_blank', 'noopener');
    },
    async loadStudentWork()
    {
      const response = await axios.get(`api/student-work/${this.id}`);

      return response.data;
    },
    async foo()
    {
      var work = await this.loadStudentWork();
      var exam = await this.loadExam(work.examId);

      const titleParts = [exam.name, exam.description].filter(Boolean);
      document.title = titleParts.join(' - ') || 'Exam';

      var answers = work.answers;
      var answerLookup = {};

      for(var i = 0; i < answers.length; i ++)
      {
        var answer = answers[i];

        if (answer.type == 'Text' && answer.text)
          answerLookup[answers[i].questionId] = answer.text;
        
        else if (answer.type == 'MultipleChoice' && answer.choiceId)
          answerLookup[answers[i].questionId] = answer.choiceId;
      }

      for(var i = 0; i < exam.questions.length; i ++)
      {
        var question = exam.questions[i];

        question.value = answerLookup[question.id];
      }

      this.exam = exam;
    },
    loadPrintContext()
    {
      let query = this.$route.query || {};

      if (!Object.keys(query).length)
      {
        const hash = window.location.hash || '';
        const queryStart = hash.indexOf('?');

        if (queryStart >= 0)
        {
          const rawQuery = hash.substring(queryStart + 1);
          const params = new URLSearchParams(rawQuery);
          const parsed = {};

          params.forEach((value, key) => {
            parsed[key] = value;
          });

          query = parsed;
        }
      }

      const studentName = query.studentName || query.student || 'Unknown Student';
      const cohortLabel = query.cohort || query.cohortName || this.$route.params.cid || 'Unknown Cohort';
      const enrollmentId = query.enrollmentId || this.$route.params.enrollmentId || '---';
      const assignmentName = query.assignmentName || '';

      this.printContext = {
        studentName,
        cohortLabel,
        enrollmentId,
        assignmentName
      };
    },
    async loadExam(id)
    {
      const response = await axios.get(`api/exams/${id}`, {
        params: { _: Date.now() }
      });

      return response.data;
    },
    async captureMultipleChoiceChange(questionId, choiceId)
    {
      this.saving = true;
      
      try
      {
        const url = `api/student-work/${this.id}/questions/${questionId}/choice`;
        const response = await axios.put(url, { choiceId : choiceId });
      }

      finally
      {
        this.saving = false;
      }
    },
    formatChoiceLetter(choice)
    {
      return String.fromCharCode(64 + choice.number);
    },
    formatChoiceText(choice)
    {
        if (choice.text && !choice.multiselect)
          return choice.text;
      
      var text = choice.multiselect;
      var input = text.split(',');
      var output = [];

      for(var i = input.length; i >= 0; i --)
      {
        var number = parseInt(input[i]);
        
        if (number) output.unshift(String.fromCharCode(64 + number));
      }

      // formatting for commas in 'A, B, and C'
      if (output.length > 2)
        for(var i = 1; i < output.length; i += 2)
          output.splice(i, 0, ', ');

      else // formatting for the word 'Both' in 'Both A and B'
        output.splice(0, 0, 'Both ');

      // formatting for the 'and' in 'A and B'
      output.splice(output.length - 1, 0, ' and ');

      return output.join('');
    },
    scaleUp(element) {
      gsap.fromTo(
        element,
        {
          scale: 0.95,
          opacity: 0,
          transformOrigin: "bottom",
        },
        {
          scale: 1,
          opacity: 1,
          duration: 0.3,
          ease: "power3.inOut",
        }
      );
    },
    attachObserver() {
      const rootElement = this.$el;
      const questions = rootElement.querySelectorAll(".card-question");

      this.observer = new IntersectionObserver(this.onElementObserved, {
        root: this.$refs.rootElement,
      });

      questions.forEach((question) => this.observer.observe(question));
    },
    onElementObserved(entries) {
      entries.forEach((entry) => {
        const element = entry.target;

        if (entry.isIntersecting) {
          const elementIsVisible = element.classList.contains("visible");

          if (!elementIsVisible) {
            this.scaleUp(element);
            element.classList.add("visible");
          }
        }
      });
    },
  },
  async created()
  {
    this.originalTitle = document.title;
    this.id = this.$route.params.id;
    this.loadPrintContext();
    this.loading = true;
    await this.foo();
    this.loading = false;
    this.$nextTick(this.attachObserver);
  },
  destroyed() {
    document.title = this.originalTitle;
  }
};
</script>

<style lang="scss" scoped>
  .choice-text
  {
      padding-left: 1em;
  }

  .choice-row-screen {
    display: block;
    margin-bottom: 18px;
  }

  .choice-option-screen {
    display: grid;
    grid-template-columns: 28px 30px minmax(0, 1fr);
    align-items: flex-start;
    column-gap: 14px;
    width: 100%;
    cursor: pointer;
  }

  .choice-input-screen {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .choice-fake-radio {
    width: 22px;
    height: 22px;
    border: 3px solid #777;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    margin-top: 2px;
    box-sizing: border-box;
    flex: 0 0 auto;
  }

  .choice-fake-radio.selected::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #448aff;
    transform: translate(-50%, -50%);
  }

  .choice-label-screen {
    font-weight: 700;
    min-width: 0;
    line-height: 1.45;
    padding-top: 1px;
  }

  .choice-text-screen {
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: normal;
    line-height: 1.45;
    display: block;
  }

  .card-title
  {
    border-top: 10px solid rgb(103, 58, 183);
    max-width: 768px;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
  }

  .card-question
  {
    border-left: 10px solid rgb(103, 58, 183);
    margin: 55px;
    margin-left: auto;
    margin-right: auto;
  }

  .md-card {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    padding: 15px;
  }

  .text-justify
  {
    text-align: justify;
    overflow-wrap: anywhere;
    word-break: normal;
  }

  .print-choice-list {
    display: none;
  }

  .print-choice-item {
    margin-bottom: 14px;
    line-height: 1.45;
  }

  .print-choice-box {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #444;
    margin-right: 8px;
    vertical-align: middle;
  }

  .print-choice-box.selected {
    background: #111;
  }

  .print-choice-label {
    font-weight: 600;
    margin-right: 6px;
  }

  .print-choice-text {
    vertical-align: middle;
  }

  @media print {
    .card-title,
    .card-question {
      opacity: 1 !important;
      transform: none !important;
      visibility: visible !important;
      box-shadow: none !important;
      border: 1px solid #d5d7da !important;
    }

    .card-title {
      border-top: 1px solid #d5d7da !important;
      margin-top: 0 !important;
      margin-bottom: 10px !important;
    }

    .card-question {
      margin: 0 0 10px 0 !important;
      padding: 10px !important;
      border-left: 1px solid #d5d7da !important;
      page-break-inside: auto;
      break-inside: auto;
    }

    .essay-question {
      page-break-before: auto;
      break-before: auto;
    }

    ::v-deep .md-card-header,
    ::v-deep .md-card-content {
      padding: 0 !important;
    }

    ::v-deep p.md-subheading {
      margin: 5px 0 10px 0 !important;
      font-size: 12pt !important;
      line-height: 1.35;
    }

    .print-choice-list {
      display: block;
      margin-top: 8px;
    }

    .choice-row-screen {
      display: none !important;
    }

    ::v-deep .md-card-expand-trigger {
      display: none !important;
    }

    ::v-deep .md-card-expand-content {
      display: block !important;
      height: auto !important;
      opacity: 1 !important;
      margin-top: 8px;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    ::v-deep .md-snackbar,
    .print-action {
      display: none !important;
    }

    .md-layout,
    .md-layout-item {
      display: block !important;
      width: 100% !important;
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
    }

    .print-choice-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      margin-bottom: 12px;
      line-height: 1.5;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .print-choice-label {
      flex: 0 0 auto;
      width: 18px;
      margin-right: 0;
    }

    .print-choice-text {
      flex: 1 1 auto;
      min-width: 0;
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: normal;
    }
  }

</style>
